/**
 * Okendo reviews widget — accessibility patch layer.
 *
 * Okendo renders client-side into the page, so these audit findings can be
 * remediated here even though the widget markup isn't in theme source:
 *  - CCC-9:        review avatars carry informative alt text but are
 *                  decorative -> alt=""
 *  - CCC-10:       media carousel prev/next buttons have tabindex="-1" and
 *                  are unreachable by keyboard -> tabindex="0"
 *  - CCH-39/41:    same buttons lack an accessible name -> aria-label
 *  - CCH-42/43/52/53: gallery slides use role="group" + aria-label
 *                  (invalid/unnecessary ARIA) -> remove
 *
 * A MutationObserver re-applies fixes as Okendo hydrates/paginates. All
 * selectors are scoped to oke-/hooper- classes and fail soft: if Okendo
 * renames classes, nothing here throws or affects the rest of the page.
 */
(function () {
  "use strict";

  var MARK = "data-a11y-patched";

  function patch(root) {
    if (!root || !root.querySelectorAll) return;

    // CCC-9: decorative review avatars
    root
      .querySelectorAll("img.oke-avatar-image:not([" + MARK + "])")
      .forEach(function (img) {
        img.setAttribute("alt", "");
        img.setAttribute(MARK, "");
      });

    // CCC-10 + CCH-39/41: carousel/gallery nav buttons
    root
      .querySelectorAll(
        [
          ".oke-mediaCarousel-prev",
          ".oke-mediaCarousel-next",
          ".oke-mediaGallery-nav-prev",
          ".oke-mediaGallery-nav-next",
        ]
          .map(function (s) {
            return s + ":not([" + MARK + "])";
          })
          .join(", ")
      )
      .forEach(function (btn) {
        btn.setAttribute("tabindex", "0");
        if (!btn.getAttribute("aria-label")) {
          var isPrev = /prev/i.test(btn.className);
          btn.setAttribute(
            "aria-label",
            btn.title || (isPrev ? "Previous slide" : "Next slide")
          );
        }
        btn.setAttribute(MARK, "");
      });

    // CCH-42/43/52/53: invalid role="group" + aria-label on gallery slides
    root
      .querySelectorAll(".hooper-slide[role='group']")
      .forEach(function (slide) {
        slide.removeAttribute("role");
        slide.removeAttribute("aria-label");
      });
  }

  var scheduled = false;
  function schedulePatch() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      patch(document);
    });
  }

  function start() {
    patch(document);
    new MutationObserver(schedulePatch).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
